/**
 * 処分業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'
import {DRIVER_DISPOSER_RESET_CONDITION} from "../../../mutation-types/driver-types";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/disposers`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      name: null,
      subscriber_number: null,
      without_invisible: true,
    },
  }
}

const disposer = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 処分業者一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param subscriber_number
     * @param without_invisible
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { name, subscriber_number, without_invisible, page, limit, format }) {
      let api_path
      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      dispatch('saveCondition', { name: name, subscriber_number: subscriber_number, without_invisible: without_invisible, limit: limit })
      const params = { name: state.condition.name, subscriber_number: state.condition.subscriber_number, without_invisible: state.condition.without_invisible, page: page, limit: limit }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if ((format != 'csv')) {
            let content = data.content
            commit(types.DRIVER_DISPOSER, { content })
            resolve(data.content)
          } else {
            resolve(data)
          }     
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          resolve(data.content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    /**
     * 処分業者のテナント内の件数取得
     * お試しプランの件数チェック用に検索条件を無視して件数を取得する
     * @param commit
     * @return {Promise<unknown>}
     */
    check ({ commit }) {
      const params = {}
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    saveCondition ({ commit, state }, { name, subscriber_number, without_invisible, limit }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _subscriber_number = (subscriber_number !== undefined) ? subscriber_number : state.condition.subscriber_number
      const _without_invisible = (without_invisible !== undefined) ? without_invisible : state.condition.without_invisible
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = { name: _name, subscriber_number: _subscriber_number, without_invisible: _without_invisible, limit: _limit }
      commit(types.DRIVER_DISPOSER_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_DISPOSER_RESET_CONDITION)
    },
  },
  mutations: {
    [types.DRIVER_DISPOSER_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_DISPOSER] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_DISPOSER_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.subscriber_number = params.subscriber_number
      state.condition.without_invisible = params.without_invisible
      state.condition.limit = params.limit
    }
  },

}

export default disposer
